function getSpreadCoordinates(canvasWidth: number, canvasHeight: number, spreadWidth: number, spreadHeight: number) {
  return {
    left: canvasWidth / 2 - spreadWidth / 2,
    top: canvasHeight / 2 - spreadHeight / 2,
  };
}

export default getSpreadCoordinates;
